export default {
    sysMenu: {
    emailManage: 'Email Marketing',
    emailAutoPushConfig: 'Auto Email Configuration',
    bulkEmail: 'Bulk Email',
    emailTemp: 'Template Management',
    emailSender: 'Sender Management',
    emailLog: 'Send Logs',
    emailUnsubscribe: 'Unsubscribe List',
    emailSendRecordStats: 'Send Report',
    seoPlatform: 'SEO/GEO Platform',
    seoPFDashboard: 'Dashboard',
    seoPFContentCenter: 'Content Center',
    seoPFArticleManagement: 'Articles',
    seoPFArticleType: 'Categories',
    seoPFArticleTag: 'Tags',
    seoPFManagerTools: 'SEO/GEO Tools',
    seoPFKeyWordCenter: 'Keywords',
    seoPFAICreateContent: 'AI Generator',
    seoPFScore: 'SEO/GEO Scorer',
    seoPFSiteConfig: 'Site Config',
    seoPFPageModel: 'Page SEO Templates',
    seoPFSiteLink: 'Internal Links',
    seoPFSiteMapManagement: 'Sitemap',
    seoPFDeclDoc: 'Site Declaration',
    seoPFHealthCheck: 'SEO Health Check',
    seoPFSiteBaseUrl: 'Site Base URL',
    seoPFAuthor: 'Authors',
    AIModelConfig: 'AI Model Configuration',
        sysAdsMgmt: 'Ad Attribution Management',
        silentMember: 'Inactive Users List',
        adsmccaccount: "Ad MCC Account Configuration",
        adsaccount: "Ad Attribution Config",
        adsreport: "Data Report & Analysis",
        adsuserpushrecord: "Push Logs",
        adsAgent: "Agent Attribution Binding",
        sys: "System",
        memberList: "Member List",
        sms: "SMS Service Provider",
        agentCostStats: 'Agent Cost',
        smsManage: "SMS Management",
        bulkSMS: "Bulk SMS",
        modelSMS: "SMS Templates",
        channelSMS: "SMS Marketing Channels",
        taskRegister: "No Deposit after Registration",
        taskSilence: "Inactive Users",
        taskOff: "Churned Users",
        welcomeSMS: "Welcome SMS",
        restorageSMS: "Re-deposit after First Deposit",
        birthdaySMS: "Birthday Reminder",
        taskVIP: "VIP Tasks",
        smsRecordStats: "SMS Reports",
        smsSendRecord: "SMS Logs",
        agentDailyStats: 'Agent Daily Performance Statistics',
        risk: "Risk Control",
        memberRiskDimensionStats: "Multi-Dimension Risk Warning",
    ipRiskDimensionStats: "Same IP User Warning",
    deviceRiskDimensionStats: "Same Device User Warning",
    bankRiskDimensionStats: "Same Bank Card User Warning",
    walletRiskDimensionStats: "Same Wallet User Warning",
        agentDailyPerformance: "Today's Agent Data",
        financial: "Finance",
        member: "Member",
        operation: "Operation",
        operationsGroup: "Operations Center",
        operationsBackgroundImage: "Background Image Management",
        systemConfig: "Menu",
        inactiveDepositors: 'Registered but Not Deposited List',
        memberChurn: "Member Churn List",
        sysConfigMgmt: "System Config",
        market: "Market",
        agentMgmt: "Agent",
        agentTransfer: "Agent Transfer",
        queryRole: "Role",
        userMgmt: "Account",
        ipWhitelist: "IP List",
        operationLog: "Operation Log",
        lang: "Language",
        bounsReport: "Bonus Report",
        agentBonusStats: "Agent Bonus Report",
        buttons: "Buttons",
        menus: "Menus",
        curreny: "Currency",
        userAccountMgmt: "User Account",
        activity: "Promotion",
        freeSpinGrant: "Free Spin Grant",
        gamePlatform: "Games",
        clientInfo: "Content",
        vip: "VIP",
        mall: "Points Mall",
        agentTotalStats: "Agent Statistics",
        gamePlatformMgmt: "Game Settings",
        gameBRoutePlatform: "B-Route Platform",
        gameListMgmt: "Sub Games",
        gameEntryMgmt: "Homepage",
        gamePromotMgmt: "Main Games",
        gameHotMgmt: "Hot Games",
        gameRecMgmt: "Rec Games",
        gameTypeMgmt: "Game Types",
        gameModuleMgmt: "Client Module Management",
        desktopGameModuleMgmt: "Desktop Module Management",
        activityWelfareMgmt: "History",
        activityManualSendMgmt: "Batch Send",
    fsBatch: "Free Spin Dispatch",
        activityMgmt: "Promotion",
        activityTypeMgmt: "Promo Types",
        activityOperateMgmt: "Special Offer Management",
        activityRedPacket: "Red Packet Rain",
        activityRedPacketMgmt: "Red Packet Rain Management",
        redPacketStats: "Red Packet Rain Statistics",
        activityRedemptionCodeMgmt: "Redemption Code Management",
        redemptionCodeMgmt: "Redemption Code Management",
        indexBotMenu: "Bottom Menu",
        indexLtMenu: "Left Menu",
        indexBanner: "Banner",
        indexContactUs: "Contact",
        indexSpopup: "Popup",
        indexStartAdvertising: "Ads",
        betRecord: 'Bet Records',
        betRecordA: 'Bet Records',
        betRecordB: 'Bet Records - B',
        manualBalance: 'Member Adjustment Records',
        manualBalanceHistory: 'Adjustment Quota Change Log',
        memberWithdrawLimit: 'Member Daily Withdrawal Limit',
        payWithdrawConfig: "Deposit/Withdraw",
        riskWithdrawConfig: "WD/Risk Config",
        riskAuthWithdraw: "Withdraw Review",
        kyc: "KYC",
        kycApply: "KYC History",
        kycCBOApply: "KYC Verification Records",
        kycSUP: "Complete KYC History",
        blacklistQuery: "Blacklist Query",
        productStok: "Stock",
        productSetting: "Products",
        exchangeRecord: "Exchange",
        payMethod: "Payment",
        callBackWhiteList: "Callback List",
        withdrawMethod: "Withdraw",
        withdrawOrderList: "Withdraw Orders",
        payOrderList: "Deposit Orders",
        paymentChannel: "Payment Channel",
        withdrawType: "Withdraw Type",
        vipExchangeMgmt: "VIP Rules",
        vipSetupMgmt: "VIP Level",
        vipLogMgmt: "VIP Progress",
        memberMgmt: "Members",
        memberDtail: "Member Detail",
        more: "More",
        analysis: "Analysis",
        inviteFriend: "Invite Friends",
        inviteFriendReport: "Invite Friends Report",
        gameCodeReoprt: "Sub Game Report",
        gameCodeReoprtB: "Sub Game Report - B",
        gamePlatReoprt: "Game Report",
        gamePlatReoprtB: "Game Report - B",
        betReport: "Bet Report",
        betReportA: "Bet Report",
        betReportB: "Bet Report - B",
        crossDayTransferSettlement: "Cross-day Transfer Settlement Analysis Dashboard",
        dashboardReport: "Dashboard",
        withdrawReport: "Withdraw Report",
        payReport: "Deposit Report",
        payOrderStat: "Recharge Dashboard",
        withdrawOrderStat: "Withdrawal Dashboard",
        rechargeSettlementAnalysis: "Deposit & Withdrawal Analysis",
        registrationConversion: "Registration & Conversion Report",
        userRegisterDistribution: "User Registration Dashboard",
        activeUserDistribution: "Active User Panel",
        onlineUserDistribution: "Online User Panel",
        valueStats: "Value Statistics Report",
        keepStats: "Deposit Retention Report",
        betKeepStats: "Bet Retention Statistics Report",
        overviewStats: "Overview Statistics Report",
        userAnalysis: "User Analysis",
        webSiteConfig: "Parameter Configuration",
        emailconfig: "Email Account Configuration",
        emailsendtempconfig: "Email Template Management",
        seoPageManager: "SEO Page Management",
        notifyManage: 'APP Notification Management',
        autoPushRecord: "Auto Push Record",
        autoPushConfig: "Auto Push Configuration",
        autoPushStats: "Auto Push Statistics",
        manualPushRecord: "Manual Push Record",
        agentTag: "Agent Tag",
        agentType: "Agent Type",
        manualPushConfig: "Manual Push Configuration",
        manualPushReport: "Manual Push Report",
        kycconfig: "kyc config",
        riskWithdrawConfigGroup: "Withdraw Risk Config",
        riskWithdrawConfigPhp: "PHP Currency Config",
        riskWithdrawConfigVnd: "VND Currency Config",
        riskWithdrawConfigCny: "CNY Currency Config",
        riskWithdrawConfigUsd: "USD Currency Config",
        riskWithdrawConfigMxn: "MXN Currency Config",
        paramConfigGroup: "Parameter Configuration",
        paramAccountAuth: "Account & Authentication",
        paramSecurityRisk: "Security & Risk",
        paramThirdPartyService: "Third-Party Services",
        paramAppMgmt: "App Management",
        paramBizRule: "Business Rules & System Params",
        paramResourceDisplay: "Resource Management",
        paramReportConfig: "Regulatory Reporting Config",
        paramRouteStrategy: "Game Route Strategy",
        messageNotify: "Messages & Notifications",
        payWithdrawConfigGroup: "Deposit & Withdrawal Config",
        withdrawBaseConfig: "Withdrawal Base Config",
        withdrawAccountBindConfig: "Withdrawal Account Binding",
        kycConfigGroup: "KYC Configuration",
        kycGlobalConfig: "KYC Global Config",
        kycNormalScene: "Regular User KYC Scenario",
        kycAgentScene: "Agent KYC Scenario",
        kycFailRule: "KYC Failure Rules",
        memberLoginLog: "Member Login Log",
        memberLoginLogReport: "Basic Information",
        memberLoginLogSummary: "Member Login Log Summary",
        luckySpin: "Lucky Spin Management",
        luckySpinTicketMgmt: "Spin Ticket Settings",
        luckySpinGrantTicketLog: "Grant Log",
        luckySpinLog: "Spin Log",
        activeMember: "Active Members List",
        depositMemberList: "Deposit Member List",
        vipMemberList: "VIP Member List",
        autoInboxMannulConfig: "Manual Inbox Message Send",
        autoInboxMessageConfig: "Auto Inbox Message Configuration",
        autoInboxMessage: "Auto Inbox Message Data",
        mannuInboxStats: "Manual Inbox Statistics",
        autoInboxStats: "Auto Inbox Statistics",
        auditReport: "Audit Report",
        auditSummary: "Summary Report",
        auditGameType: "Game Type Report",
        auditBranchGameType: "Branch Game Type Report",
        auditProvider: "Provider Report",
        auditProviderGameType: "Provider Game Type",
        auditGameOrder: "Game Order",
        auditPlayerCount: "Player Count Report",
        auditPlayerAggregator: "Player Aggregator",
        auditCloseReportUser: "Closed reporting users",
        closeReportUser: "Game Route Change Log",
        newsManagement: "News Management",
        newsListMgmt: "News Articles",
        newsCategoryMgmt: "News Categories",
        newsTagMgmt: "News Tags",
        newsInternalLinkMgmt: "Internal Link Keywords",
        newsCategory: "News Categories",
        newsTag: "News Tags",
        newsArticle: "News Articles",
        userLeaderboard: "User Ranking",
        depositLeaderboard: "Deposit Leaderboard",
        withdrawLeaderboard: "Withdrawal Leaderboard",
        promotionLeaderboard: "Promotion Leaderboard",
        winLeaderboard: "Win Leaderboard",
        lossLeaderboard: "Loss Leaderboard",
        betLeaderboard: "Bet Leaderboard",
        gameRanking: "Game Ranking",
        leaderboardActivity: "Leaderboard Activity",
        leaderboardActivityActivityList: "Activity List",
        leaderboardActivityBoardRecords: "Board Records",
        leaderboardActivityAwardRecords: "Award Records",
        importLog: "Import Log Management",
        inviterList: "Invite Friends List",
        jeepneyUserList: "Fission User Query",
        rebateList: "Rebate Records",
        negativeProfitMember: "Negative Profit Member List",
        tagMgmt: "Tag Management",
        manualTag: "Manual Tag",
        autoTag: "Auto Tag",
        chickActivity: "Check-in Activity",
        chickActivityMgmt: "Activity Configuration",
        chickActivityReport: "Data Report",
        chickActivityUserStats: "User Status Query",
        jeepneyActivity: "Fission Activity",
        jeepneyActivityMgmt: "Fission Activity Configuration",
        jeepneyBlockRewardMgmt: "Track and Reward Settings",
        jeepneySettlementMgmt: "Settlement Settings",
        jeepneyFunnelAnalysis: "Jeepney Funnel Analysis",
        treasureBox: "Treasure Box",
        treasureBoxMgmt: "Treasure Box",
        treasureBoxConfig: "Box Settings",
        treasureBoxStats: "Box Statistics",
        treasureBoxRecords: "Box Distribution Records",
        treasureBoxRecord: "Box Distribution Records",
        report: "Financial Reports",
    },
    // Button names: keyed by the language-neutral buttonCode (platformButton.buttonCode).
    // When a key is missing the page falls back to the stored buttonName (operator-created buttons).
    sysButton: {
        "accountInfo-BankCardStatus": "Member Details - Account Info - Bank Card Enable/Disable",
        "accountInfo-BankCardUnbind": "Member Details - Account Info - Bank Card Bind/Unbind",
        "accountInfo-FlowManualAdjust": "Member Details - Account Info - Manual Turnover Adjustment",
        "accountInfo-WalletManualAdjust": "Member Details - Account Info - Manual Wallet Adjustment",
        "accountInfo-WalletStatus": "Member Details - Account Info - Wallet Enable/Disable",
        "accountInfo-WalletTakeBack": "Member Details - Account Info - Wallet Retrieval",
        "accountInfo-WalletUnbind": "Member Details - Account Info - Wallet Bind/Unbind",
        "accountInfo-manualAdjustPoint": "Member Details - Account Points - Manual Point Adjustment",
        adminRiskUnLock: "Admin Withdrawal Risk Control Unlock",
        adminRiskView: "Admin Withdrawal Risk Control Search",
        "batchDistribution-Participation": "Batch Distribution - Participation Ticket",
        "batchDistribution-cash": "Batch Distribution - Cash",
        "batchDistribution-integral": "Batch Distribution - Points",
        "chargeOrderManager-comfirmOrder": "Deposit Order Management - Confirm Order",
        "chargeOrderManager-export": "Deposit Order Management - Export",
        "exchangeRecord-export": "Exchange Records - Export",
        "manualBalance-export": "Member Balance Adjustment Records Export",
        "manualBalanceHistory-export": "Export",
        "memberInfo-AgentName": "Member Details - Basic Info - Upper Agent",
        "memberInfo-Email": "Member Details - Basic Info - Email",
        "memberInfo-Identity": "Member Details - Basic Info - Identity Info",
        "memberInfo-Phone": "Member Details - Basic Info - Phone Number",
        "memberInfo-RegulatoryReportClose": "Member Details - Disable Data Reporting",
        "memberInfo-RegulatoryReportTab": "Member Details - Game Route Status Tab",
        "memberInfo-Remark": "Member Details - Basic Info - Remark",
        "memberInfo-ResetPassword": "Member Details - Basic Info - Reset Login Password",
        "memberInfo-ResetWithdrawPassword": "Member Details - Basic Info - Reset Withdrawal Password",
        "memberInfo-WithdrawLimit": "Member Details - Basic Info - Withdrawal Limit",
        "memberWithdrawLimit-edit": "Member Daily Withdrawal Limit - Edit",
        "memberInfo-RiskLevel": "Member Details - Basic Info - Risk Control",
        "memberInfo-UserTypeSetting": "User Type Setting",
        "memberInfo-View-Phone": "Member Details - Basic Info - View Phone Number",
        "memberInfo-export": "Member Data Export",
        "memberInfo-kyc-edit": "Withdrawal KYC - Edit",
        "memberInfo-upload": "Member Data Upload",
        "memberchurn-export": "Member Churn List - Export",
        "memberchurn-query": "Member Churn List - Query",
        "memberkycinfo-batchSetFail": "KYC Application Records - Batch Set as Failed",
        "memberkycinfo-batchSetSuccess": "KYC Application Records - Batch Set as Passed",
        "memberkycinfo-docmentData": "KYC Info Edit - Document",
        "memberkycinfo-historicalData": "KYC Application Records - Historical Data",
        "memberkycinfo-idCard": "KYC Application Records - ID Document",
        "memberkycinfo-setFail": "KYC Application Records - Set as Failed",
        "memberkycinfo-setSuccess": "KYC Application Records - Set as Passed",
        "membernorecharge-export": "Registered Without Deposit List - Export",
        "membernorecharge-query": "Registered Without Deposit List - Query",
        "newsArticle-add": "News Articles - Add Article",
        "newsArticle-approve": "News Articles - Approve",
        "newsArticle-delete": "News Articles - Delete",
        "newsArticle-edit": "News Articles - Edit",
        "newsArticle-reject": "News Articles - Reject",
        "newsArticle-seo-edit": "News Articles - SEO Edit",
        opUserAdjustQuota: "Quota Management",
        opUserDelete: "Delete",
        opUserDisable: "Disable",
        opUserEdit: "Edit",
        opUserModifyRole: "Modify Role",
        opUserResetGoogleAuth: "Reset Google Authenticator",
        opUserResetLoginPassword: "Reset Login Password",
        "email-log-export": "Email Send Log - Export",
        "sms-log-export": "SMS Logs - Export Failure List",
        "withdrawOrderList-adminUnLock": "Withdrawal Order Management - Admin Unlock",
        "withdrawOrderList-confirmWithdrawal": "Withdrawal Order Management - Confirm Payout",
        "withdrawOrderList-export": "Withdrawal Order Management - Export",
        "withdrawOrderList-refusedWithdrawal": "Withdrawal Order Management - Refuse Withdrawal",
        "withdrawOrderList-reject": "Withdrawal Order Management - Reject",
        "withdrawOrderList-replaceWithdrawal": "Withdrawal Order Management - Third-Party Payout"
    },
    menu: {
        add: "Add",
        edit: "Edit",
        menu: "Menu",
        parentMenu: "Parent Menu Node",
        selectParentMenu: "Select Parent Menu Node",
        menuLevel: "Menu Level",
        selectMenuLevel: "Please Select Menu Level",
        menuCode: "Menu Code",
        menuName: "Menu Name",
        isLeaf: "Is Leaf Node",
        yes: "Yes",
        no: "No",
        menuUrl: "Backend URL Address",
        enterMenuUrl: "Please Enter Backend URL Address",
        menuOrder: "Menu Order"
    },
    tagView: {
        closeCurrent: "Close Current",
        closeOthers: "Close Others",
        closeAll: "Close All",
        home: "Home"
    },
    avatar: {
        personalCenter: "Personal Center",
        changePassword: "Change Password",
        logout: "Logout"
    },
}
